import $ from 'jquery'

const baseOptions = {
    language: 'ru',
    width: '100%',
}

function initSimpleSelect($element) {
    if ($element.hasClass('select2-hidden-accessible')) {
        return
    }

    $element.select2({
        ...baseOptions,
        placeholder: $element.data('placeholder') || $element.attr('placeholder') || undefined,
        allowClear: !$element.prop('multiple'),
    })
}

function initAjaxSelect($element) {
    if ($element.hasClass('select2-hidden-accessible')) {
        return
    }

    $element.select2({
        ...baseOptions,
        placeholder: 'Выберите опцию',
        minimumInputLength: 3,
        allowClear: false,
        ajax: {
            dataType: 'json',
            data(params) {
                return {
                    q: $.trim(params.term),
                    term: params.term || '',
                    page: params.page || 1,
                    perPage: params.perPage || 25,
                }
            },
            processResults(response, params) {
                params.page = params.page || 1

                return {
                    results: response.data,
                    pagination: {
                        more: response.last_page !== params.page
                    }
                }
            }
        }
    })
}

export function initSelect2(scope = document) {
    $(scope).find('.js-select2-on').each(function () {
        initSimpleSelect($(this))
    })

    $(scope).find('.js-select-ajax').each(function () {
        initAjaxSelect($(this))
    })
}

initSelect2()
